import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=305d30ea&"
import script from "./PersonalInfo.vue?vue&type=script&lang=ts&"
export * from "./PersonalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalInfo.vue"
export default component.exports